import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';

// 채팅 답글 기능입니다.
const useChatReply = () => {
  // 채팅 답글 시 대상 메세지
  const [parentMessage, setParentMessage] = React.useState<Message | null>(null);

  return {
    parentMessage,
    setParentMessage,
  };
};

export default useChatReply;
